import React from "react";
import { Box } from "@material-ui/core";
import dayjs from "dayjs";
import { WishlistManagementForm } from "halifax";
import "./styles.scss";

export const FavoritesSection = () => {
  return (
    <Box className="favorites-section">
      <WishlistManagementForm
        stayDates={{
          fromDate: dayjs().add(3, "day").toDate(),
          untilDate: dayjs()
            .add(3 + 7, "day")
            .toDate(),
        }}
        guests={{
          adults: 2,
          children: [],
          pets: 0,
        }}
      />
    </Box>
  );
};
